import React from "react"
import { css } from "@emotion/core"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { planningPageMetadata } from "../../../utils/seo"

import * as mixins from "../../../utils/mixins"

import PlanningSecondaryImage from "../../components/imageComponents/planning/planning-two"

import TopDisplayImageCont from "../../components/imageComponents/TopDisplayImageCont"
import TopImage from "../../components/imageComponents/optimized/planning"
import { PlanningTopImageTitle } from "../../components/layoutComponents/top-image-title"

import * as TextComponent from "../../components/textComponents"
import * as LayoutComponent from "../../components/layoutComponents"
import * as InteractiveComponent from "../../components/interactiveComponents"

import {
  HeaderNavBar,
  HeaderNavBarBackLink,
} from "../../components/layoutComponents/header-nav-bar"

function PlanningPage() {
  return (
    <Layout>
      <SEO
        title="Site Planning"
        description="Marin County's Landscaping Experts. The right materials and methods, guaranteed results."
        meta={planningPageMetadata}
      />
      <HeaderNavBar>
        <HeaderNavBarBackLink to="/">BACK TO SERVICES</HeaderNavBarBackLink>
      </HeaderNavBar>

      <TopDisplayImageCont>
        <TopImage />
        <PlanningTopImageTitle />
      </TopDisplayImageCont>

      <LayoutComponent.SectionContainer
        styles={css`
          ${mixins.device.mobileX} {
            padding-bottom: 0.15rem;
          }
        `}
      >
        <TextComponent.BodyText>
          No two landscaping jobs are the same. Understanding your site is
          essential for project success. We take into account terrain, soil
          qualities, prevailing winds, depth of the frost line, and native
          plants and shrubbery.
        </TextComponent.BodyText>
      </LayoutComponent.SectionContainer>

      <LayoutComponent.SectionTitleBanner>
        WHAT&apos;S THE PLAN?
      </LayoutComponent.SectionTitleBanner>

      <LayoutComponent.SectionContainer
        styles={css`
          padding-bottom: 0;
        `}
      >
        <TextComponent.BodyText
          styles={css`
            ${mixins.device.tablet} {
              margin: 0.5rem 0 1.25rem;
            }
          `}
        >
          <TextComponent.BodyBold
            css={css`
              margin-bottom: ;
            `}
          >
            We work within your budget to develop a plan that will be cost
            effective and successful. Our process:
          </TextComponent.BodyBold>
        </TextComponent.BodyText>

        <TextComponent.TreeListItem>
          Meet with you to identify what your project goals are
        </TextComponent.TreeListItem>

        <TextComponent.TreeListItem>
          Complete a thorough site assessment to gather info about your site and
          potential challenges
        </TextComponent.TreeListItem>

        <TextComponent.TreeListItem>
          Provide you with the plan, addressing the unique challenges and
          opportunities on your site
        </TextComponent.TreeListItem>

        <TextComponent.TreeListItem>
          Address any concerns that you may have, making modifications as
          required
        </TextComponent.TreeListItem>
      </LayoutComponent.SectionContainer>

      <div
        css={css`
          /* height: 14rem; */
          max-height: 10rem;

          ${mixins.device.tablet} {
            max-height: 14rem;
          }
        `}
      >
        <PlanningSecondaryImage />
      </div>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText
          styles={css`
            margin: 1rem 0 1.5rem;

            ${mixins.device.mobileX} {
              margin: 0.5rem 0 1.65rem;
            }
          `}
        >
          <TextComponent.BodyBold>Have questions?</TextComponent.BodyBold> Get
          in touch to find out how we can save you time and money on your
          project.
        </TextComponent.BodyText>

        <InteractiveComponent.Button to="/contact-us/">
          CONTACT US
        </InteractiveComponent.Button>
      </LayoutComponent.SectionContainer>
    </Layout>
  )
}

export default PlanningPage
